import { useEffect } from 'react'
import { useAppDispatch } from '../../redux/hooks'
import { useAppSelector } from '../../redux/store'
import { fetchTeamMembers } from '../../redux/teamMember/actions'
import {
  selectErrorTeamMembers,
  selectLoadingTeamMembers,
  selectTeamMembers,
} from '../../redux/teamMember/selector'

export function useFetchTeamMembers() {
  const dispatch = useAppDispatch()
  const loading = useAppSelector(selectLoadingTeamMembers)
  const error = useAppSelector(selectErrorTeamMembers)
  const teamMembers = useAppSelector(selectTeamMembers)

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchTeamMembers()).unwrap()
    }

    fetchData()
  }, [dispatch])

  return { teamMembers, loading, error }
}
